import { SystemStyleObject } from "@chakra-ui/styled-system";

export const attr = <T>(condition: unknown, value: T) =>
  condition ? value : undefined;

// To change the font weight without effecting the layout:
//   1. Set element's fontWeight to wider value (medium)
//   2. Add a pseudoelement with fontWeight set to narrower value (normal)
//   3. Toggle visibility of element and pseudo-element based on state
export const activeFontWeightWithConsistentWidth = (
  titleAttr: string,
  activeSelector: string,
  inactiveStyles: SystemStyleObject,
  activeStyles: SystemStyleObject,
): SystemStyleObject => ({
  // only do all this if title attr is set
  [`&[${titleAttr}]`]: {
    visibility: "hidden",
    position: "relative",
    ...activeStyles,
    _before: {
      ...inactiveStyles,
      visibility: "visible",
      content: `attr(${titleAttr})`,
      position: "absolute",
      marginLeft: "0.5px",
    },
    [activeSelector]: {
      visibility: "visible",
      _before: {
        visibility: "hidden",
      },
    },
  },
  // otherwise, use styles as normal
  [`&:not([${titleAttr}])`]: {
    ...inactiveStyles,
    [activeSelector]: {
      ...activeStyles,
    },
  },
});
